RivalIQ.apps.Analyze.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    function createPath(curation) {
        const configurationId = curation.getProp('configurationId');
        return `/dashboards/${configurationId}/create`;
    }

    const EmptyView = Marionette.ItemView.extend({
        ui: {
            deleteBtn: '.x-delete'
        },

        eventsNotToDebounce: {
            'click @ui.deleteBtn': 'onDelete'
        },

        className: 'favorites empty',
        template: '#emptyFavoritesTemplate',

        serializeData: function () {
            const me = this;
            const curationId = me.dashboardModel.getCurationId();

            const allWidgets = me.dashboardModel.getUnfilteredWidgets();

            const isReadOnly = RivalIQ.state.user.isReadOnly();
            const isValidDashboard = true;
            let emptyReason = RivalIQ.strings.favorites_all_widgets_hidden_empty_reason;

            if (allWidgets.isEmpty()) {
                emptyReason = RivalIQ.strings.favorites_no_widgets_empty_reason;
            }

            if (isReadOnly) {
                emptyReason = RivalIQ.strings.favorites_no_widgets_readonly_reason;
            }

            return {
                isReadOnly: isReadOnly,
                isDeletable: (curationId === RivalIQ.enums.curation.DASHBOARDS),
                url: createPath(me.dashboardModel),
                emptyReason: emptyReason,
                isValidDashboard: isValidDashboard
            };
        },

        onDelete: function () {
            const me = this;
            RivalIQ.apps.Favorites.utils.showDashboardDeleteModal(me);
        }
    });

    // If the widget to be added is full page, make sure we break the page
    // before that.
    // NOTE: This could be replaced by `page-break: before;` now.
    function onRow(child, elBuffer) {
        if (child.dashboardModel.getSize() === RivalIQ.enums.widgetSize.FULL_PAGE) {
            $(elBuffer.lastChild).addClass('page-break-after');
        }
    }

    const CollectionView = Dashboard.views.ColumnWidgets.extend({
        columnBootstrapSize: function () {
            const me = this;

            if (me.dashboardModel.isExportingPNG()) {
                return 'sm';
            } else {
                return 'lg';
            }
        },
        getEmptyView: function () {
            const me = this;
            return EmptyView.extend({
                dashboardModel: me.dashboardModel
            });
        },
        // NOTE we need to do the same logic before, and after a row is
        // appended. we do the former to force widgets preceding a full
        // page widget to break, and we do the latter so that proceeding a
        // full page widget there is a break (whether widgets follow or not).
        afterAppendRow: onRow,
        beforeAppendRow: onRow
    });

    const CreateLink = RivalIQ.views.Link.extend({
        className: 'btn btn-primary',

        attributes: function () {
            const me = this;
            const chartTypes = RivalIQ.apps.Favorites.data.chartTypes;
            const collection = me.getOption('collection');

            const widgets = collection.reduce(function (sum, widget) {
                return (chartTypes[widget.widgetId] ? sum + 1 : sum);
            }, 0);
            const limit = RivalIQ.state.product.get('customDashboardsWidgetLimit');

            if (widgets < limit) {
                return {
                    href: createPath(me.model)
                };
            }

            return {
                disabled: true,
                'data-toggle': 'tooltip',
                'data-placement': 'auto',
                style: 'pointer-events: auto;',
                title: RivalIQ.str('dashboards_curation_widgets_limit', limit)
            };
        },

        onShow: function () {
            const me = this;
            me.$el.tooltip();
        }
    });

    const Layout = Dashboard.views.ColumnCurationView.extend({
        template: '#analyzeFavoritesLayoutTemplate',
        collectionView: CollectionView,

        collectionEvents: {
            'remove': 'showActions',
            'reset': 'showActions',
            'dismissibleDestroyed': 'refreshWidgets'
        },

        refreshWidgets: function () {
            // After the authorizationWidget is dismissed, it should be filtered from the list of widgets
            const me = this;
            me.dashboardModel.getWidgets();
        },

        showActions: function () {
            const me = this;
            const size = _.size(me.collection);

            me.actions.reset();

            if (RivalIQ.state.user.isReadOnly()) {
                return;
            }

            if (size > 1) {
                me.showReorderAction();
            }

            if (me.dashboardModel.id === RivalIQ.enums.curation.DASHBOARDS && size > 0) {
                me.showEditAction();
            }

            if (size !== 0) {
                me.showCreateAction();
            }

            me.showExportDropdown();
        },

        showEditAction: function () {
            const me = this;

            const configurationId = me.getProp('configurationId');
            me.actions.show(new RivalIQ.views.Link({
                attributes: {
                    href: `/dashboards/${configurationId}/edit`
                },
                linkName: 'Edit',
                className: 'btn btn-default'
            }), {
                preventDestroy: true
            });
        },

        showReorderAction: function () {
            const me = this;

            me.actions.show(new RivalIQ.views.Link({
                linkName: 'Reorder Charts',
                className: 'btn btn-default',
                action: function () {
                    RivalIQ.execute('show:modal', new App.views.ReorderModal({
                        dashboardModel: me.dashboardModel,
                        filteredCollection: me.dashboardModel.getReorderableWidgets(),
                        collection: me.dashboardModel.getUnfilteredWidgets()
                    }));
                }
            }), {
                preventDestroy: true
            });
        },

        showCreateAction: function () {
            const me = this;

            me.actions.show(new CreateLink({
                model: me,
                collection: me.collection,
                linkName: [
                    $.tagHtml('i', {
                        class: ['fa', 'fa-fw', 'fa-plus']
                    }),
                    $.tagHtml('span', {
                        text: 'Create New Chart'
                    })
                ].join('')
            }), {
                preventDestroy: true
            });
        }
    });

    const PdfLayout = Dashboard.views.ExportWidgets.extend({
        childView: CollectionView
    });

    function redirectMissing(curation) {

        // this app is also used as a "catch all" for other app paths in the read only user case
        if (curation.redirectToDashboard) {
            RivalIQ.execute('history:navigate', '/dashboards', {
                trigger: true
            });
            return false;
        }

        const instanceId = curation.getProp('instanceId');
        if (instanceId) {
            const instanceDefinition = _.find(curation.configuration.get('definitions'), {
                instanceId: instanceId
            });
            if (!instanceDefinition) {
                // If we couldn't find the instanceDefinition, that means the url is pointing at an instanceId
                // that is not in this configuration (deleted or maybe the url doesn't make sense for the current
                // landscape). loadCuration is called from a curation before filter, so we can return a path to
                // cause a redirect.
                return curation.getBasePath();
            }
        }
    }

    function removeReadonlyHrefs(router) {
        _.defer(function () {
            requestAnimationFrame(function () {
                const anchors = $('a[href], button[href]');
                const routes = _.get(router, ['redirectToDashboardRoutes']);
                _.each(anchors, function (a) {
                    const $a = $(a);
                    let href = $a.attr('href');
                    href = href.replace(/^\/+|\/+$/g, '');
                    _.some(routes, function (route) {
                        if (route.test(href)) {
                            $a.removeAttr('href').css('pointer-events', 'none');
                            return true;
                        }
                    });
                });
            });
        });
    }

    function redirectMissingConfiguration(deferred) {
        let url;

        deferred = (deferred || new $.Deferred());

        const dashboard = RivalIQ.state.dashboards.first();
        if (!dashboard) {
            if (RivalIQ.state.user.isReadOnly()) {
                url = '/dashboards/empty';
            } else {
                url = '/dashboards/new';
            }
        } else {
            url = `/dashboards/${dashboard.id}`;
        }

        return deferred.resolve(url);
    }

    const customDashboardWelcomeWidget = {
        instanceId: 'custom-dashboard-welcome-widget',
        widgetId: RivalIQ.enums.widgetTypes.LIMITATION,
        props: {
            className: 'widget-multi-additional-auth',
            closeable: false,
            img: null,
            description: RivalIQ.strings.dashboards_welcome_panel_description_html,
            shouldFilterFromReorder: true,
            state: 'account',
            title: RivalIQ.strings.dashboards_welcome_panel_title,
            type: 'info',
            upsell: false,
            actions: [
                {
                    className: 'pointer dismiss',
                    html: RivalIQ.strings.dashboards_welcome_panel_dismissal_html
                }
            ]
        },
        supportedExportFormats: []
    };

    curations.Favorites = Dashboard.models.Curation.mixin({
        mixins: {
            exportHD: Dashboard.mixins.ExportHD,
            curationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy
        },

        widgetsView: Layout,
        exportWidgetsView: PdfLayout,
        getChildView: function () {
            const me = this;
            const router = me.router;

            // When the layout or the detail view has finished loading, strip links
            const View = Dashboard.models.Curation.prototype.getChildView.apply(me, arguments);
            return View.extend({
                initialize: function () {
                    const me = this;

                    me.listenTo(RivalIQ, 'modal:loading:finished', function () {
                        removeReadonlyHrefs(router);
                    });

                    me.listenTo(RivalIQ, 'modal:shown', function () {
                        removeReadonlyHrefs(router);
                    });

                    View.prototype.initialize.apply(me, arguments);
                    me.on('loading:finished', function () {
                        removeReadonlyHrefs(router);
                    });
                }
            });
        },
        title: function () {
            const me = this;
            return me.getName();
        },

        beforeFilters: [
            redirectMissing
        ],

        loadConfiguration: function () {
            const me = this;
            const props = me.getProps();

            // NOTE if we don't have a `configurationId` then we shouldn't load
            // the configuration, we should instead redirect somewhere "smart"
            if (!props.configurationId) {
                return redirectMissingConfiguration();
            }

            const deferred = new $.Deferred();

            RivalIQ.data.configuration.fetch(me, props, {
                force: true
            })
                .done(function (configuration) {
                    const configurationProps = configuration.getProps();
                    const isCreatedByAutomation = _.get(configurationProps, 'createdByAutomation', false);
                    const isReadOnly = RivalIQ.state.user.isReadOnly();

                    const definitions = configuration.get('definitions');
                    const hasWelcomeWidget = Boolean(definitions.filter(function (definition) {
                        return definition.instanceId === 'custom-dashboard-welcome-widget';
                    }).length);

                    if (!hasWelcomeWidget && isCreatedByAutomation && !isReadOnly) {
                        definitions.splice(0, 0, customDashboardWelcomeWidget);
                    }

                    deferred.resolve(configuration);
                })
                .fail(function (xhr) {
                    if (xhr.status === 404) {
                        redirectMissingConfiguration(deferred);
                    } else {
                        deferred.reject(xhr);
                    }
                });

            return deferred;
        },

        // Overwritten to show a message for restricted widgets
        shouldFilterWidgetFromExport: function (format, widget) {
            return widget.supportedExportFormats && !_.includes(widget.supportedExportFormats, format);
        },

        getBasePath: function (props) {
            const me = this;
            return Dashboard.models.Curation.prototype.getBasePath.call(me, _.extend({}, props, {
                configurationId: me.getProp('configurationId')
            }));
        },

        getBackLinkName: function () {
            const me = this;
            return me.title();
        },

        getReorderableWidgets: function () {
            const me = this;
            return me.getWidgets().filter(function (widget) {
                return !widget.getProp('shouldFilterFromReorder');
            });
        }
    });

    curations.Favorites.redirectMissing = redirectMissing;
});
